<div class="main-container">
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>
  <!-- Chat Modal -->
  <!-- <div class="chat-modal" *ngIf="isChatOpen && showChatHistoryButton">
    <div class="chat-content">
      <div class="chat-header">
        <h3 style="font-weight: 700; color: #000; margin-right: 3px">
          Comment History
        </h3>
        <button class="chat-modal-close-btn" (click)="closeChat()">
          Close
        </button>
      </div>

      <div class="chat-body">
        <p>
          <strong>RFQ - Buyer Comments</strong> sent an RFQ on
          {{ formatDateToDDMMYYYY(headerData.rfqDate) }}
        </p>
        <p>
          RFQ Ref Number: <strong>{{ headerData.rfqRefNumber }}</strong>
        </p>

        
        <div class="vessel-info">
          <p>
            Vessel Name: <strong>{{ headerData.vesselName }}</strong>
          </p>
          <p>
            Vessel IMO Number: <strong>{{ headerData.vesselImoNumber }}</strong>
          </p>
          <p>
            Port Name: <strong>{{ headerData.portName }}</strong>
          </p>
          <p>
            Vessel ETA:
            <strong>{{ formatDateToDDMMYYYY(headerData.vesselEta) }}</strong>
          </p>
          <p>
            Vessel ETD:
            <strong>{{ formatDateToDDMMYYYY(headerData.vesselEtd) }}</strong>
          </p>
        </div>

       

        <div class="chat-messages">
          <div
            *ngFor="let msg of messages"
            class="msg"
            [ngClass]="{
              incoming: msg.sender !== 'You',
              outgoing: msg.sender === 'You'
            }"
          >
            <span class="text">{{ msg.message }}</span>
            <span class="time">{{ msg.time }}</span>
            
          </div>
        </div>
      </div>

      
      <div class="chat-footer">
        <label class="file-upload">
          📎
          <input type="file" hidden (change)="onFileSelected($event)" />
        </label>
        <input
          type="text"
          placeholder="Type a message"
          [(ngModel)]="newMessage"
        />
        <button (click)="sendMessage()">Send</button>
      </div>
    </div>
  </div> -->
  <div
    class="title-text"
    style="display: flex; justify-content: space-between; align-items: center"
  >
    <div>
      {{ headerData?.rfqRefNumber }}
      <!-- <span class="status">
                Quote By : {{headerData?.quotedByDate | date:'dd/MM/yyyy'}}
            </span> -->
    </div>
    <div
      style="
        display: flex;
        padding: 10px;
        justify-content: space-around;
        gap: 10px;
      "
    >
      <button
        *ngIf="userRole == 'Suppliers'"
        class="right-button"
        (click)="back()"
      >
        Back
      </button>
      <!-- <button
        *ngIf="userRole == 'Suppliers'"
        class="right-button"
        (click)="rfqActions('download')"
      >
        Download file
      </button> -->

      <!-- <button class="right-button" (click)="rfqActions('decline')" 
            [disabled]="headerData?.docStatus == 'Declined' || headerData?.docStatus == 'Submitted'"
            [ngClass]="{'disabled-button': headerData?.docStatus == 'Declined' || headerData?.docStatus == 'Submitted'}">
            {{ headerData?.docStatus == 'Declined' ? 'Declined' : 'Decline' }}
            </button> -->

    <ng-container *ngIf="headerData?.rfqStatus =='Unactioned'">
      <button
        *ngIf="userRole == 'Suppliers'"
        class="right-button"
        (click)="rfqActions('decline')"
        [disabled]="
          headerData?.docStatus == 'Declined' ||
          headerData?.docStatus == 'Submitted' ||
          headerData?.docStatus == 'Lost'
        "
        [ngClass]="{
          'declined-disabled-button':
            headerData?.docStatus == 'Declined' ||
            headerData?.docStatus == 'Lost',
          'disabled-button': headerData?.docStatus == 'Submitted'
        }"
      >
        {{ headerData?.docStatus == "Declined" ? "Declined" : "Decline" }}
      </button>

      <button
        *ngIf="userRole == 'Suppliers'"
        class="right-button"
        (click)="rfqActions('acknowledge')"
        [disabled]="headerData?.docStatus == 'Acknowledged'"
        [ngClass]="{
          'acknowledged-disabled-button':
            headerData?.docStatus == 'Acknowledged',
          'disabled-button': headerData?.docStatus == 'Submitted',
          'declined-disabled-button':
            headerData?.docStatus == 'Declined' ||
            headerData?.docStatus == 'Lost'
        }"
      >
        {{
          headerData?.docStatus == "Acknowledged"
            ? "Acknowledged"
            : "Acknowledge"
        }}
      </button>

      <button
        *ngIf="userRole == 'Suppliers'"
        class="right-button"
        (click)="createQuote()"
        [disabled]="
          headerData?.docStatus == 'Declined' ||
          headerData?.docStatus == 'Submitted' ||
          headerData?.docStatus == 'Lost'
        "
        [ngClass]="{
          'disabled-button': headerData?.docStatus == 'Submitted',
          'declined-disabled-button':
            headerData?.docStatus == 'Declined' ||
            headerData?.docStatus == 'Lost'
        }"
      >
        {{ headerData?.docStatus == "Submitted" ? "Quoted" : "Quote" }}
      </button>
      </ng-container>
    </div>
  </div>
  <div class="status">
    Quote By : {{ headerData?.quotedByDate | date : "dd/MM/yyyy" }}
  </div>

  <div
    style="
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
    "
  >
    <div>
      <div class="title-text">{{ headerData?.buyerCompanyName }}</div>
      <div
        style="
          display: flex;
          align-items: center;
          font-size: 22px;
          margin-bottom: 10px;
        "
      >
        <mat-icon style="margin-right: 8px">person</mat-icon>
        <div style="font-size: 16px">{{ headerData?.contact }}</div>
      </div>
    </div>
    <div style="display: flex; flex-direction: column; align-items: flex-end">
      <div class="Header-Details-Toggle">
        <!-- <button *ngIf="this.headerData?.docStatus!=='Unactioned'" class="right-button" (click)="draft()">Draft</button> -->
        <button
          class="right-button"
          (click)="toggleShowHeaderDetails({ checked: !showDetailSection })"
          style="margin-left: 10px"
        >
          {{ showDetailSection ? "Hide Header" : "Show Header" }}
        </button>
      </div>
      <div style="margin-top: 20px">
        <button
          class="right-button"
          style="
            display: flex;
            justify-content: center;
            gap: 5px;
            align-items: center;
          "
          (click)="toggleBuyerAttachmentImage(true)"
        >
          <mat-icon>library_books</mat-icon>
          {{ buyerAttachmentUrl.length }} Related Documents
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="Header-Details-Toggle" style="float:right;padding:0px 20px;">
        <div style="float: right;">
            <button class="right-button">
                Draft
            </button>
            <button class="right-button" (click)="toggleShowHeaderDetails({checked: !showDetailSection})" style="margin-left:10px">
                {{ showDetailSection ? 'Hide Header' : 'Show Header' }}
            </button>
        </div>
       
    </div>
     -->
  <!-- <div style="float: right;">
        <button class="right-button" style="display: flex; justify-content: center; gap: 5px;align-items: center;">
            <mat-icon>library_books</mat-icon>
            0 Related Documents
        </button>
    </div> -->
  <div
    style="display: flex; flex-direction: row; padding-top: 32px; height: 90vh"
  >
    <div
      [ngClass]="{
        'full-width-container1': !showDetailSection,
        'half-width-container1': showDetailSection
      }"
      class="content-box"
      style="overflow-y: auto; height: 85vh; scroll-behavior: smooth"
    >
      <!-- <div class="title-text">{{headerData?.buyerCompanyName}}</div>
            <div style="display: flex; align-items: center;font-size: 22px;margin-bottom: 10px;">
                <mat-icon style="margin-right: 8px;">person</mat-icon>
                <div style="font-size: 16px;">{{headerData?.contact}}</div>
            </div> -->
      <!-- <span class="status">
                Quote By : {{headerData?.quotedByDate | date:'dd/MM/yyyy'}}
            </span> -->
      <!-- <div class="title-section">
                
                <button class="right-button" style="display: flex; justify-content: center; gap: 5px;align-items: center;">
                    <mat-icon>library_books</mat-icon>
                    0 Related Documents
                </button>

                    <div class="wrap-description-toggle" style="margin-bottom: 32px;">
                          <mat-slide-toggle (change)="toggleShowHeaderDetails($event)">All Header Details</mat-slide-toggle>
                      </div>
  
    
            </div> -->

      <div class="title-section">
        <div class="span-container">
          <div class="supplier-comments">
            <span class="label">Supplier Comments:</span>
            <span>No comments </span>
            <a *ngIf="showChatHistoryButton" (click)="openChat()"
              >View Full Comment History</a
            >
          </div>

          <!-- <div class="supplier-terms">
            <span class="label">Supplier Terms and Conditions:</span>
            <span>No terms and conditions</span>
          </div> -->
        </div>
      </div>

      <div style="display: flex; justify-content: space-between; padding: 10px">
        <p class="light-text">
          Currency: {{ headerData?.currencyId?.currencyName }}
        </p>
        <mat-slide-toggle
          (change)="toggleWrapDescription($event)"
          [checked]="isWrapDescription"
          >Word Wrap</mat-slide-toggle
        >
      </div>

      <ngx-datatable
        #supplierTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="lineItemData"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [externalPaging]="false"
        [externalSorting]="false"
        [scrollbarH]="false"
      >
        <ngx-datatable-column
          name="#"
          [minWidth]="80"
          [maxWidth]="80"
          [flexGrow]="0"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.serialNo }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="Part Number"
          [minWidth]="120"
          [maxWidth]="120"
          [flexGrow]="0"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.partNumber }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Item Description" [flexGrow]="2">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- {{ row.itemDescription }}   -->
            <div [class.wrap-text]="isWrapDescription">
              {{ row.itemDescription }}
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="UOM"
          [minWidth]="120"
          [maxWidth]="120"
          [flexGrow]="0"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.uom }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="Quantity"
          [minWidth]="120"
          [maxWidth]="120"
          [flexGrow]="0"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.quantity }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Buyer Comments" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div [class.wrap-text]="isWrapDescription">
              {{ row.buyerComments }}
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          name="Attachments"
          [minWidth]="120"
          [maxWidth]="120"
          [flexGrow]="0"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button
              type="button"
              mat-icon-button
              class="visibility-icon-button"
              (click)="toggleRfqAttachmentImage(true, row)"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <!-- side bar vertical scrolls -->
    <!-- <div class="sidebar" style="overflow: auto;" *ngIf="showDetailSection"> -->
    <div
      class="sidebar"
      [ngClass]="{
        'full-width-container2': !showDetailSection,
        'half-width-container2': showDetailSection
      }"
    >
      <div class="sidebar-title">
        <div class="sidebar-title-text">Header Details</div>
      </div>

      <div class="sidebar-content">
        <!-- <div style="display: flex; padding: 10px; justify-content: space-around;">
                <button class="right-button" (click)="back()">Back</button>
                <button class="right-button" (click)="rfqActions('download')">Download file</button>

                <button class="right-button" (click)="rfqActions('decline')" 
                [disabled]="headerData?.docStatus == 'Declined'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Declined'}">Decline</button>

                <button class="right-button" (click)="rfqActions('acknowledge')" 
                [disabled]="headerData?.docStatus == 'Acknowledged'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Acknowledged'}">Acknowledge</button>
                
                <button class="right-button" (click)="createQuote()">Quote</button>
            </div>
     -->
        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form1')"
            >Buyer Company Details
            <mat-icon>
              {{ isForm1Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm1Expand">
            <ul class="list-group">
              <li class="list-group-item">
                Buyer Name : {{ headerData?.buyerCompanyName }}
              </li>
              <li class="list-group-item">
                Email Id : {{ headerData?.companyEmailId }}
              </li>
              <li class="list-group-item">
                Phone : {{ headerData?.companyPhoneNumber }}
              </li>
              <li class="list-group-item">
                Fax : {{ headerData?.companyFax }}
              </li>
              <li class="list-group-item">
                Address : {{ headerData?.companyAddress }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form2')"
          >
            Buyer Details
            <mat-icon>
              {{ isForm2Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm2Expand">
            <ul class="list-group">
              <li class="list-group-item">
                Contact : {{ headerData?.contact }}
              </li>
              <li class="list-group-item">
                Job Title : {{ headerData?.jobTitle }}
              </li>
              <li class="list-group-item">
                Email Id : {{ headerData?.emailId }}
              </li>
              <li class="list-group-item">Phone : {{ headerData?.phone }}</li>
              <li class="list-group-item">Fax : {{ headerData?.fax }}</li>
              <li class="list-group-item">
                Address : {{ headerData?.address }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form3')"
          >
            RFQ Details
            <mat-icon>
              {{ isForm3Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm3Expand">
            <ul class="list-group">
              <li class="list-group-item">
                RFQ Ref Number : {{ headerData?.rfqRefNumber }}
              </li>
              <li class="list-group-item">
                RFQ Date : {{ headerData?.rfqDate | date : "dd/MM/yyyy" }}
              </li>
              <li class="list-group-item">
                Quote by Date :
                {{ headerData?.quotedByDate | date : "dd/MM/yyyy" }}
              </li>
              <li class="list-group-item">
                Document Number : {{ headerData?.docNumber }}
              </li>
              <li class="list-group-item">
                Tracking Number : {{ headerData?.trackingNumber }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              padding-bottom: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form4')"
          >
            Vessel Details
            <mat-icon>
              {{ isForm4Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm4Expand">
            <ul class="list-group">
              <li class="list-group-item">
                Vessel Name : {{ headerData?.vessel?.vesselName }}
              </li>
              <li class="list-group-item">
                Vessel IMO Number : {{ headerData?.vessel?.imoNumber }}
              </li>
              <li class="list-group-item">
                Vessel Type : {{ headerData?.vessel?.typeOfVessel }}
              </li>
              <li class="list-group-item">
                Class : {{ headerData?.vessel?.class }}
              </li>
              <li class="list-group-item">
                Hull Number : {{ headerData?.vessel?.hullNumber }}
              </li>
              <li class="list-group-item">
                Yard Name : {{ headerData?.vessel?.yardName }}
              </li>
              <li class="list-group-item">
                Year Built : {{ headerData?.vessel?.yearBuilt }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              padding-bottom: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form5')"
          >
            Port Details
            <mat-icon>
              {{ isForm5Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm5Expand">
            <ul class="list-group">
              <li class="list-group-item">
                Port Name : {{ headerData?.portName }}
              </li>
              <li class="list-group-item">
                Port Code : {{ headerData?.portCode }}
              </li>
              <li class="list-group-item">
                Vessel ETA : {{ headerData?.vesselEta | date : "dd/MM/yyyy" }}
              </li>
              <li class="list-group-item">
                Vessel ETD : {{ headerData?.vesselEtd | date : "dd/MM/yyyy" }}
              </li>
              <li class="list-group-item">
                Vessel ETB : {{ headerData?.vesselEtb | date : "dd/MM/yyyy" }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form6')"
          >
            Port Agent Details
            <mat-icon>
              {{ isForm6Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm6Expand">
            <ul class="list-group">
              <li class="list-group-item">
                Port Agency Name : {{ headerData?.portAgencyName }}
              </li>
              <li class="list-group-item">
                Port Agent Name : {{ headerData?.portAgentName }}
              </li>
              <li class="list-group-item">
                Port Agent Phone Number : {{ headerData?.rfqPortAgentphone }}
              </li>
              <li class="list-group-item">
                Port Agent Contact : {{ headerData?.rfqPortAgentContact }}
              </li>
              <li class="list-group-item">
                Port Agent Fax : {{ headerData?.rfqPortAgentfax }}
              </li>
              <li class="list-group-item">
                Port Agent Email Id : {{ headerData?.rfqPortAgentemailId }}
              </li>
              <li class="list-group-item">
                Address : {{ headerData?.rfqPortAgentaddress }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form7')"
          >
            Freight Forwarder Details
            <mat-icon>
              {{ isForm7Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm7Expand">
            <ul class="list-group">
              <li class="list-group-item">
                <!-- Freight Forwarder Company Name :
                {{ headerData?.freightForwarderId }} -->
                 Freight Forwarder Company Name :
                {{ headerData?.freightForwarderCompanyName }}
              </li>
              <li class="list-group-item">PIC : {{ headerData?.rffdPic }}</li>
              <li class="list-group-item">
                Job Title : {{ headerData?.rffdjobTitle }}
              </li>
              <li class="list-group-item">
                Email Id : {{ headerData?.rffdemailId }}
              </li>
              <li class="list-group-item">
                Phone : {{ headerData?.rffdphone }}
              </li>
              <li class="list-group-item">Fax : {{ headerData?.rffdfax }}</li>
              <li class="list-group-item">
                Address : {{ headerData?.rffdaddress }}
              </li>
              <li class="list-group-item">
                Packaging : {{ headerData?.packaging }}
              </li>
              <li class="list-group-item">
                Mode of Transport : {{ headerData?.modeOfTransport }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form8')"
          >
            Delivery Details
            <mat-icon>
              {{ isForm8Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm8Expand">
            <ul class="list-group">
              <li class="list-group-item">
                Request Delivery Date :
                {{ headerData?.requestDeliveryDate | date : "dd/MM/yyyy" }}
              </li>
              <li class="list-group-item">
                Lead Time In Delivery : {{ headerData?.leadTimeInDelivery }}
              </li>
              <li class="list-group-item">
                Contact : {{ headerData?.Deliverycontact }}
              </li>
              <li class="list-group-item">
                Email Id : {{ headerData?.Deliveryemail }}
              </li>
              <li class="list-group-item">
                Phone : {{ headerData?.Deliverycontact }}
              </li>
              <li class="list-group-item">
                Fax : {{ headerData?.Deliveryfax }}
              </li>
              <li class="list-group-item">
                Delivery Terms And Conditions :
                {{ headerData?.deliveryTermsAndConditions }}
              </li>
              <li class="list-group-item">
                Delivery Address : {{ headerData?.deliveryAddress }}
              </li>
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form9')"
          >
            Invoice Address
            <mat-icon>
              {{ isForm9Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm9Expand">
            <ul class="list-group">
              <li class="list-group-item">
                {{ headerData?.invoiceAddress }}
              </li>
             
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form10')"
          >
            Buyer Payment Terms
            <mat-icon>
              {{ isForm10Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm10Expand">
            <ul class="list-group">
              <li class="list-group-item">
                {{ headerData?.buyerPaymentTerms }}
              </li>
             
            </ul>
          </div>
        </div>

        <div class="header-form">
          <span
            style="
              padding-left: 16px;
              padding-top: 16px;
              margin-bottom: 16px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
            "
            (click)="toggleVisibility('form11')"
          >
            Buyer Terms & Conditions
            <mat-icon>
              {{ isForm11Expand ? "minimize" : "add" }}
            </mat-icon>
          </span>

          <div *ngIf="isForm11Expand">
            <ul class="list-group">
              <li class="list-group-item">
                {{ headerData?.buyerTermsAndCondition }}
              </li>
             
            </ul>
          </div>
        </div>

        <!-- <div class="button-container">
                <button type="submit" class="save-button" (click)="saveVessel()">
                  <mat-icon>save</mat-icon>
                </button>
                <button type="button" class="close-button" (click)="toggleNewVessel(false)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </div> -->
      </div>
    </div>
  </div>

  <div class="section"></div>
</div>

<!-- Popup for confirmation -->
<div class="namemodal" *ngIf="showDeclineConfirmationDialogue">
  <div class="modalContent">
    <div class="p-6 text-center">
      <div class="flex justify-center mb-4">
        <div
          class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
        >
          <mat-icon
            class="text-orange-600"
            style="font-size: 40px; height: 100%; width: 100%"
            >warning</mat-icon
          >
        </div>
      </div>
      <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
      <p class="mb-6">
        Are you sure you want to decline this request for quotation?<br />Select
        a reason from the dropdown
      </p>
      <mat-form-field class="full-width" color="accent">
        <mat-label>Decline reason</mat-label>
        <mat-select [(ngModel)]="declineReason">
          <mat-option value="Price is too high"> Price is too high</mat-option>
          <mat-option value="Unable to meet specifications">
            Unable to meet specifications</mat-option
          >
          <mat-option value="Not available at this time">
            Not available at this time</mat-option
          >
          <mat-option value="No capacity to fulfill the order">
            No capacity to fulfill the order</mat-option
          >
          <mat-option value="Conflict of interest">
            Conflict of interest</mat-option
          >
          <mat-option value="Other"> Other</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex justify-center gap-4">
        <button
          mat-raised-button
          color="primary"
          (click)="declineRfq()"
          [disabled]="declineReason == ''"
        >
          Yes, Decline
        </button>
        <button mat-stroked-button (click)="cancelDecline()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- <div
  class="rfqattachmentcarouselContainer"
  *ngIf="rfqattachmentSection"
>
  <div class="carousel-close-button">
    <button
      class="rfqattachment-close-button"
      (click)="toggleRfqAttachmentImage(false)"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <div class="rfqattachmentcarousel">
    <div class="rfqattachmentcarouselImageContainer">
      <div
        class="rfqattachmentcarouselimageContainerInner"
        *ngIf="rfqattachmentImages[0]?.slice(-3) === 'pdf'"
      >
        <pdf-viewer
          [src]="rfqattachmentImages[0]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="rfqattachmentimage-container-inner"
        *ngIf="rfqattachmentImages[0].slice(-3) !== 'pdf'"
      >
        <img
          [src]="rfqattachmentImages[0]"
          [alt]="'rfqattachment image'"
          class="rfqattachmentcarousel-image"
        />
      </div>
    </div>
  </div>
</div> -->

<!-- when we click the Preview Icon -->

<div
  class="blur"
  *ngIf="rfqattachmentSection"
  (click)="toggleRfqAttachmentImage(false)"
></div>
<div class="carousel-container" *ngIf="rfqattachmentSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="toggleRfqAttachmentImage(false)"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <div
        class="rfqattachmentcarouselimageContainerInner"
        *ngIf="isPdf(rfqattachmentImages[currentIndex])"
      >
        <pdf-viewer
          [src]="rfqattachmentImages[currentIndex]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="rfqattachmentimage-container-inner"
        *ngIf="!isPdf(rfqattachmentImages[currentIndex])"
      >
        <img
          [src]="rfqattachmentImages[currentIndex]"
          [alt]="'rfqattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>

<!-- SLIDE-IN SIDEBAR -->
<div class="buyer-sidebar-container slide-in" *ngIf="buyerAttachmentSection">
  <!-- HEADER -->
  <div class="popup-header">
    <h2>Related Documents</h2>
    <button class="close-btn" (click)="toggleBuyerAttachmentImage(false)">
      Close
    </button>
  </div>

  <!-- BUYER INFO -->
  <div class="buyer-info">
    <mat-icon>description</mat-icon>
    <span>
      <strong>{{ headerData?.buyerCompanyName }}</strong> sent an RFQ on
      <strong>{{ headerData?.rfqDate | date : "dd/MM/yyyy" }}</strong
      ><br />
      RFQ Ref Number : <strong>{{ headerData?.rfqRefNumber }}</strong>
    </span>
  </div>

  <!-- ATTACHMENT BOX -->
  <!-- <div class="buyer-attachment">
    <mat-icon>attach_file</mat-icon>
    <span class="attachment-label">`${buyerAttachmentUrl.length} Attachments`</span>
    <span class="attachment-size">138 KB</span>
  </div>
  
    <div *ngIf="this.buyerAttachmentUrl?.trim()" style="display: flex; flex-direction: column;">

        <div class="headerfile-scroll-wrapper">
            <div class="headerfile-name-box" *ngFor="let file of buyerAttachmentUrl">
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; padding-right: 5px;">
                <span style="font-size: 13px;">{{ file.name }}</span>

                <button mat-icon-button matTooltip="Preview" matTooltipPosition="below"
                        (click)="toggleHeaderAttachmentImage(true, file.s3_path)">
                <mat-icon>visibility</mat-icon>
                </button>
            </div>
            </div>
        </div>
    </div> -->

  <div class="buyer-attachment" (click)="isCollapsed = !isCollapsed">
    <mat-icon>attach_file</mat-icon>
    <span class="attachment-label"
      >{{ buyerAttachmentUrl.length }} Attachments</span
    >
    <mat-icon class="collapse-icon">
      {{ isCollapsed ? "keyboard_arrow_down" : "keyboard_arrow_up" }}
    </mat-icon>
  </div>

  <!-- Attachments Section -->
  <div
    *ngIf="!isCollapsed && buyerAttachmentUrl?.length"
    class="headerfile-scroll-wrapper"
  >
    <div class="headerfile-name-box" *ngFor="let file of buyerAttachmentUrl">
      <div class="file-row">
        <span class="file-name">{{ file.name }}</span>
        <button
          mat-icon-button
          matTooltip="Preview"
          matTooltipPosition="below"
          (click)="toggleBuyerHeaderAttachmentImage(true, file.s3_path)"
        >
          <mat-icon>visibility</mat-icon>
        </button>
        <!-- Download Button -->
        <!-- <button mat-icon-button matTooltip="Download" matTooltipPosition="below"
                    (click)="downloadAttachment(file.s3_path, file.name)">
                <mat-icon>get_app</mat-icon>
            </button> -->
      </div>
    </div>
  </div>
</div>

<div
  class="blur"
  *ngIf="buyerHeaderAttachmentSection"
  (click)="toggleBuyerHeaderAttachmentImage(false)"
></div>
<div class="carousel-container" *ngIf="buyerHeaderAttachmentSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="toggleBuyerHeaderAttachmentImage(false)"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
          &#10094;
        </button> -->

    <div class="carousel-image-container">
      <div
        class="rfqattachmentcarouselimageContainerInner"
        *ngIf="isPdf(buyerHeaderAttachmentUrl)"
      >
        <pdf-viewer
          [src]="buyerHeaderAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="rfqattachmentimage-container-inner"
        *ngIf="!isPdf(buyerHeaderAttachmentUrl)"
      >
        <img
          [src]="buyerHeaderAttachmentUrl"
          [alt]="'rfqattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
          &#10095;
        </button> -->
  </div>
</div>
